// Burger.js
import React from 'react'
import { StyledBurger } from './Burger.styled'

const Burger = ({ isOpen, open, close }) => {
  return (
    <StyledBurger isOpen={isOpen} onClick={isOpen ? close : open} tabIndex='2'>
      <div />
      <div />
      <div />
    </StyledBurger>
  )
}

export default Burger
